import { all } from 'redux-saga/effects';
import LoginSaga from './LoginSaga';
import EntitiesSaga from './EntitiesSaga';

export default function* rootSaga() {
  yield all([
    LoginSaga(),
    EntitiesSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js